<div class="rectangle-container appliance-details-info">
    <div class="rx-app-flex-container-column">
        <div class="appliance-details-info__title">
            {{ 'ApplianceDetails.ApplianceDetailsTitle' | translate }}
        </div>
        <div class="general-info-body rx-app-flex-container-row" [class.appliance-details-info__body]="isResponsive">
            <div class="info-box rx-app-flex">
                <div class="fields-container">
                    <div class="field">
                        <div class="field-name rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--align-center" id="appliance-print-upperAppliance">
                            {{ 'ApplianceDetails.UpperArch' | translate }}:
                            <img class="appliance-details-info__selector"
                                [src]="isUpperChecked | mapper : getSrcForRadioButtonImg" alt="checked">
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-name rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--align-center" id="appliance-print-lowerAppliance">
                            {{ 'ApplianceDetails.LowerArch' | translate }}:
                            <img class="appliance-details-info__selector"
                                [src]="isLowerChecked | mapper : getSrcForRadioButtonImg" alt="checked">
                        </div>
                    </div>
                </div>
            </div>
            <div class="rx-separator vertical" [class.appliance-details-info__separator]="isResponsive"></div>
            <div class="info-box rx-app-flex">
                <div class="fields-container">
                    <div class="field" id="appliance-print-appliancetype">
                        <div class="field-name">
                            {{ 'ApplianceDetails.Type' | translate }}:
                        </div>
                        <div class="field-info">{{applianceType | doubleHyphen }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
